<template>

<div class="full-page section-image" data-color="black" data-image="/assets/img/login-background.jpg">
<div class="content">

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <h1>Welcome</h1>
                <p class="text-muted">Hello {{ user }}. Enter a password and then click the button below to create an account.</p>

                <div class="form-group">
                  <input id="password" v-model="password" type="password" class="form-control" placeholder="Password">
                </div>

                <div class="row">
                  <div class="col-6">
                    <button type="button" v-on:click="signupSubmit()" class="btn btn-primary px-4">Sign up</button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <font color='red'>{{ error }}</font>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</div>
</template>

<script>
import Vue from 'vue'

import router from '../../router'
import apiService from '../../services/api.service'
import config from '../../config'

export default {
  name: 'Signup',
  data: function () {
    return {
      user: this.$route.query.user.replace(" ","+"),
      password: '',
      token: this.$route.query.token,
      error: ''
    }
  },
  mounted() {
    console.log("before create");
    sessionStorage.refresh = "true";
    if (localStorage['id_token_for'] != null && localStorage['id_token'] != null && localStorage['id_token_for'] == this.user)
    {
      console.log("user is already logged in " + this.user);
      router.push('/')
    }
    else
    {
      var encodedUser = encodeURI(this.user);
      encodedUser = encodedUser.replace("+", "%2B");

      console.log("---- does user exist? " + this.user + "," + encodedUser);

      apiService.get('/auth/exists/',
      { 
        headers: {'X-Consumer-Username': encodedUser} 
      }).then(function (response) {
        console.log(response)
        if (response && response.data.Result.indexOf("custom_id") > 0)
        {
          console.log("go to login");
          router.push('/auth/login');
        }
      });
    }
  },
  methods: {
    signupSubmit: function (event) {
      this.error = '';

      if (this.token == null || this.token.length < 5) {
        // this.error = "Token is missing or invalid.";
        Vue.toasted.error("Token is missing or invalid.", { duration: 3500 })
        return;
      } 

      if (this.password.length < 5) {
        // this.error = "Please enter a longer password.";
        Vue.toasted.error("Please enter a longer password.", { duration: 3500 })
        return;
      } 

      var postData = "token=" + this.token;
      var rfqRedirectId = this.$route.query.rfq;
      var newUser = this.user;
      var newPassword = this.password;

      apiService.post('/auth/signup/', postData,
      { 
        headers: {'X-Consumer-Username': this.user, 'X-Consumer-Password': this.password} 
      })

      .then(function (response) {
        console.log('signup.vue success ' + JSON.stringify(response))
        Vue.toasted.success("Account created successfully!", { duration: 3500 })

        console.log("about to login " + newUser + " " + rfqRedirectId);
        apiService.get('/auth/key/', {
          auth: {
            username: newUser,
            password: newPassword
          }
        }).then(function (response) {
          console.log('signup.vue login success ' + JSON.stringify(response))
          localStorage.setItem('id_token', response.data.Result)
          localStorage.setItem('id_token_for', newUser)

          if (rfqRedirectId != null)
          {
            console.log("about to redirect to " + rfqRedirectId)
            router.push('/rfq/view/'+rfqRedirectId)
          }
          else
          {
            router.push('/')
          }

        }).catch(function (error) {
          console.log('signup.vue error' + error)
          Vue.toasted.error("There was a problem logging in, please try again.", { duration: 3500 })
          router.push('/auth/login')
        })

      }).catch(function (error) {
        var errorDetails = JSON.stringify(error);
        console.log('signup.vue ' + errorDetails)
        if (errorDetails.indexOf(":409") > 0)
        {
          Vue.toasted.error("This email address already exists.", { duration: 3500 })
        }
        else
        {
          Vue.toasted.error("There was a problem creating this account.", { duration: 3500 })
        }

      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// signup.vue?0b5b6c9d